import { useState } from 'react';

/**
 * Holds the text-truncation flag for the ECG viewer tooltip. Keeps a boolean state and returns it together with its setter so the tooltip can report clipped content.
 *
 * @returns The truncated flag and its setter.
 */
export const useTooltipFormatter = () => {
  const [truncated, setTruncated] = useState(false);

  return { truncated, setTruncated };
};
